if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.upsellData = this.getUpsellData();
        this.upsellEl = this.querySelector('.product-upsell');

        document.body.addEventListener(
          'variantChange',
          this.handleVariantChange.bind(this),
        ); //user changes main product variant

        this.atc = JSON.parse(this.getAttribute('data-atc'));

        this.addEventListener('change', this.updateUpsellId.bind(this));

        /*
        fetch(
          window.Shopify.routes.root +
            `recommendations/products?product_id=${this.dataset.product}&limit=4&section_id=${this.dataset.section}&intent=related`,
        )
          .then((response) => response.text())
          .then((text) => {
            const template = document.createElement('template');
            template.innerHTML = text;
            const recommendations = template.content.querySelectorAll(
              '.product-upsell__item',
            );
            if (recommendations.length > 0) {
              const upsellContainer = this.querySelector(
                '.product-upsell__container',
              );
              upsellContainer.append(...recommendations);
              this.querySelector('.slider').init();
            }
          });
	  */
      }

      handleVariantChange() {
        //data-color-current has been changed by variant
        var current_location =
          document.querySelector('main')?.dataset.location ?? 'en';
        var current_currency =
          document.querySelector('main')?.dataset.currency ?? 'AUD';

        var money = new Intl.NumberFormat(current_location, {
          style: 'currency',
          currency: current_currency,
          currencyDisplay: 'narrowSymbol',
        });

        //set prices of all upsell
        const all_upsells = this.upsellEl.querySelectorAll(
          '.product-upsell__item',
        );
        var current_color = this.upsellEl.dataset.colorCurrent;

        this.upsellData.forEach((product, index) => {
          for (let i = 0; i < product.length; i++) {
            const variant = product[i];
            var lower_title = variant.title.toLowerCase();
            var variant_id = variant.id;

            if (lower_title.includes(current_color)) {
              let upsell_item = all_upsells[index];

              //set price of current index
              let price = upsell_item.querySelector('.upsell_price');

              price.innerHTML = money.format(variant.price / 100);

              if (this.atc) {
                //if product has atc, set variant id
                //Check to see if upsell item has variants
                var upsell_select = upsell_item.querySelector(
                  '.product-upsell__variant',
                );

                //quick atc
                var quick_atc = upsell_item.querySelector('.quick-add__submit');
                if (quick_atc) {
                  var current_url = quick_atc.dataset.productUrl.split('?')[0];
                  quick_atc.dataset.productUrl = `${current_url}?variant=${variant_id}`;
                }

                //Variant select needs to pick the previous matching value
                var newly_selected_option = upsell_item.querySelector(
                  `[data-title="${variant.title}"]`,
                );

                if (newly_selected_option) {
                  newly_selected_option.selected = true;

                  if (variant.available) {
                    this.enableATC(upsell_item);
                  } else {
                    this.disableATC(upsell_item);
                  }
                }
              }
              break;
            }
          }
        });
      }

      getUpsellData() {
        this.upsellData =
          this.upsellData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );

        return this.upsellData;
      }

      updateUpsellId(e) {
        var changed_upsell = e.target.closest('.product-upsell__item');
        var input_value = e.target.value;

        if (!changed_upsell || !input_value) {
          this.disableATC(changed_upsell);
          return;
        }

        var id_input = changed_upsell.querySelector('input[name="id"]');

        if (!id_input) {
          this.disableATC(changed_upsell);
          return;
        }

        //check if product is available
        let available_string = e.target.selectedOptions[0].dataset.available;
        let available = JSON.parse(available_string);
        if (available) {
          this.enableATC(changed_upsell);
        } else {
          this.disableATC(changed_upsell);
        }

        id_input.value = input_value;
      }

      disableATC(upsell_item) {
        const submit_button = upsell_item.querySelector('.quick-add__submit');

        if (!submit_button) return;

        const soldOutMessage = submit_button.querySelector('.sold-out-message');

        if (soldOutMessage) {
          submit_button.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }

        submit_button.setAttribute('aria-disabled', true);
        submit_button.setAttribute('disabled', 'disabled');
      }

      enableATC(upsell_item) {
        const submit_button = upsell_item.querySelector('.quick-add__submit');

        if (!submit_button) return;

        const soldOutMessage = submit_button.querySelector('.sold-out-message');

        if (soldOutMessage) {
          submit_button.querySelector('span').classList.remove('hidden');
          soldOutMessage.classList.add('hidden');
        }

        submit_button.setAttribute('aria-disabled', false);
        submit_button.removeAttribute('disabled');
      }
    },
  );
}
